<template>
  <a-card :bordered="false" :bodyStyle="bodyStyle" style="margin: 0px 30px 20px 30px" hoverable>
    <a-row style="margin-top: 19px">
      <a-col :span="24">
        <img
          src="@/assets/Site/ExhibitionBoard/news.png"
          alt=""
          style="width: 20px; height: 22px; margin-top: -5px"
        />
        <div class="titleNews" style="" @click="newsDatils(data)">{{ data.title }}</div>
        <div style="display: flex; margin-left: 20px">
          <div style="display: inline; margin-left: 14px" v-if="showTrue">
            <img
              :src="returnImage(data)"
              alt=""
              style="width: 140px; height: 90px; border-radius: 4px; margin-top: 16px"
            />
          </div>
          <div style="display: inline; margin-left: 14px">
            <div class="contentNews" style="" @click="newsDatils(data)">
              {{ textDal(data.parseFailedWebResult.content) }}
            </div>
            <div style="margin-top: 12px">
              <div class="newsOscen" style="">
                <img
                  src="@/assets/Site/ExhibitionBoard/news.png"
                  alt=""
                  style="width: 22px; height: 22px; margin-top: -5px"
                />
                {{ data.parseFailedWebResult.source }}
              </div>
              <div class="newsTime" style="">{{ data.parseFailedWebResult.publishTime }}</div>
              <a class="ywlj" style="right: 0" @click="windowOpen(data.url)">原文链接</a>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>

  

</template>

<script>
import moment from 'moment'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['data', 'tabState'],
  data() {
    return {
      stateName: this.tabState,
      type: '',
      typeName: '',
      case: 'style1',
      isA: true,
      isB: false,
      isC: false,
      isD: false,
      showTrue: true,
      bodyStyle: {
        padding: '20px 70px 30px 39px'
      }
    }
  },
  created() {
    // this.List = this.$store.state.localLX
  },
  computed: {},

  beforeDestroy() {},
  methods: {
    textDal(data) {
      if(data == null ){
        return
      }
      let sourceL = data.length
      if (sourceL > 450) {
        return data.substring(0, 450) + '...'
      } else {
        return data
      }
    },
    newsDatils(data) {
      window.open('/#/news-detail-view/' + data.parseFailedWebResult.id)
    },
    compareSrc(param) {
      if (param === null) {
        if (this.data.typeMetaId === 53) {
          return this.defaultSrcMl
        }
        return this.defaultSrc
      } else {
        return `/pmc/hdfs/show/app_icon/${this.data.id}`
      }
    },
    returnImage(data) {
      let str = data.parseFailedWebResult
      let source = false
      for (let i in str) {
        if (i === 'fileList') {
          source = true
        }
      }
      if (source) {
        if (str.fileList.length > 0) {
          return str.fileList[0]
        } else {
          this.showTrue = false
        }
      } else {
        this.showTrue = false
      }
    },
    resetDATE(record) {
      const a = moment(record).format('YYYY-MM-DD HH:mm:ss')
      const b = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      if (moment(b).diff(moment(a), 'minutes') <= 0) {
        return '刚刚更新'
      }
      if (moment(b).diff(moment(a), 'minutes') <= 60) {
        return moment(b).diff(moment(a), 'minutes') + '分钟前更新'
      }
      if (
        moment(b).diff(moment(a), 'minutes') > 60 &&
        moment(b).diff(moment(a), 'minutes') < 60 * 24
      ) {
        return moment(b).diff(moment(a), 'hours') + '小时前更新'
      }
      if (moment(b).diff(moment(a), 'days') < 30) {
        return moment(b).diff(moment(a), 'days') + '天前更新'
      } else {
        return moment(b).diff(moment(a), 'months') + '月前更新'
      }
    },
    pictureReturn(id) {
      pictureFind(id).then((res) => {
        return res
      })
    },
    changePage() {
      // this.$router.push({ path: '/productCenter/productOverview' })
      this.$store.commit('saveLocalData', this.data)
      this.$router.push({ path: `/productMangement/productOverview/overview/${this.data.id}` })
    },
    dema(data) {
      switch (data) {
        case 7:
          return '#9DAAC9'
        case 8:
          return '#DEC898'
        case 9:
          return '#99C1D3'
        case 10:
          return '#B9A5D5'
        case 11:
          return '#98C08E'
        default:
          break
      }
    },
    checkColor() {
      // const color = this.dema(data)
      const a = {
        width: '116px',
        height: '30px',
        background: this.data.typeMetaColor,
        'border-radius': '2px',
        position: 'absolute',
        right: '-30px',
        top: '-30px'
      }
      return a
    },
    checkList(data) {
      let returname = ''
      this.List.forEach((element) => {
        if (data === element.id) {
          returname = element.metaValue
        }
      })
      return returname
    },
    windowOpen(data) {
      window.open(data)
    }
  }
}
</script>

<style scoped>
#dividerFormat /deep/ .ant-divider,
.ant-divider-vertical {
  margin: 0 20px;
}
.titleNews {
  margin-top: 4px;
  display: inline;
  font-size: 19px;
  font-weight: 500;
  color: #333333;
  line-height: 14px;
  margin-left: 12px;
}
.contentNews {
  font-size: 13px;
  font-weight: 480;
  color: #333333;
  line-height: 22px;
  margin-top: 17px;
}
.newsOscen {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  line-height: 14px;
  display: inline;
}
.newsTime {
  font-size: 12px;
  font-weight: 480;
  color: #bbbbbb;
  line-height: 14px;
  display: inline;
  margin-left: 30px;
}
.ywlj {
  font-size: 12px;
  font-weight: 480;
  color: #bbbbbb;
  line-height: 14px;
  display: inline;
  float: right;
  margin-right: 12px;
  text-decoration: underline;
  position: absolute;
}
</style>
